/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.33333 17.9999C7.82222 17.9999 7.38889 17.8221 7.03333 17.4666C6.67778 17.111 6.5 16.6777 6.5 16.1666V7.16659C6.5 6.65547 6.67778 6.22214 7.03333 5.86659C7.38889 5.51103 7.82222 5.33325 8.33333 5.33325H17.3333C17.8444 5.33325 18.2778 5.51103 18.6333 5.86659C18.9889 6.22214 19.1667 6.65547 19.1667 7.16659V16.1666C19.1667 16.6777 18.9889 17.111 18.6333 17.4666C18.2778 17.8221 17.8444 17.9999 17.3333 17.9999H8.33333ZM8.33333 16.9999H17.3333C17.5667 16.9999 17.764 16.9193 17.9253 16.7579C18.0862 16.597 18.1667 16.3999 18.1667 16.1666V7.16659C18.1667 6.93325 18.0862 6.73592 17.9253 6.57459C17.764 6.4137 17.5667 6.33325 17.3333 6.33325H8.33333C8.1 6.33325 7.90289 6.4137 7.742 6.57459C7.58067 6.73592 7.5 6.93325 7.5 7.16659V16.1666C7.5 16.3999 7.58067 16.597 7.742 16.7579C7.90289 16.9193 8.1 16.9999 8.33333 16.9999ZM9.23333 15.3333L11.5 13.0666L12.7167 14.2666L14.1667 12.4333L16.4833 15.3333H9.23333ZM10.3333 10.1666C10.0111 10.1666 9.73622 10.0528 9.50867 9.82525C9.28067 9.59725 9.16667 9.32214 9.16667 8.99992C9.16667 8.6777 9.28067 8.40259 9.50867 8.17459C9.73622 7.94703 10.0111 7.83325 10.3333 7.83325C10.6556 7.83325 10.9307 7.94703 11.1587 8.17459C11.3862 8.40259 11.5 8.6777 11.5 8.99992C11.5 9.32214 11.3862 9.59725 11.1587 9.82525C10.9307 10.0528 10.6556 10.1666 10.3333 10.1666Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
